<template>
  <section>
    <div id="loginPage">

      <div style="display: flex; height: 100vh;">
        <div id="loginContainer" style="margin-left: auto; margin-right: auto; align-items: center;">
          <div :class="{ failure: failure }" ref="loginCard">
            <div class="card bordernone bs-small" style="margin-top: 200px;">
              <div class="card-header bggreen text-white" style="padding: 20px 1.25rem;">
                <div ref="cardHeader flex" style="display: flex;">
                  <img class="mw100" src="../assets/img/cube.png" style="max-width: 30px; max-height: 30px" />
                  <h4 class="mb0 ml10">Login</h4>
                </div>
              </div>
              <div class="card-body" ref="cardBody">
                <h6 v-if="maintenanceMode" style="color: #e25353">
                  Under Maintenance, sorry for the inconvenience
                </h6>
                <h6 v-else-if="locked" style="color: #e25353">
                  We've temporarily locked your account after too many failed requests. Please contact the Spacesaver IT
                  dept.
                </h6>
                <form @submit.prevent="loginNEW">
                  <input type="hidden" name="_token" :value="csrfToken" />
                  <small v-if="usedEmail" style="color: #6f6e6e">There is an issue with your username</small>
                  <div class="input-group mb-3" ref="usernameGroup">
                    <input v-if="maintenanceMode || locked" disabled class="form-control" type="text" v-model="username"
                      placeholder="Username" />
                    <input v-else class="form-control" type="text" v-model="username" placeholder="Username"
                      @change="checkUserLock()" />
                    <div class="input-group-append">
                      <span class="input-group-text"><span class="material-icons"
                          style="font-size: 20px; color: #777373;">
                          person
                        </span></span>
                    </div>
                  </div>

                  <div class="input-group" ref="passwordGroup">
                    <input v-if="maintenanceMode || locked" disabled class="form-control" type="password"
                      v-model="password" placeholder="Password" />
                    <input v-else class="form-control" :type="showPW ? 'text' : 'password'" v-model="password"
                      placeholder="Password" autocomplete="on" />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <span v-show="showPW" @click="hidePassWord">
                          <span class="material-icons" style="font-size: 20px; color: #777373;">
                            visibility_off
                          </span>

                        </span>
                        <span v-show="!showPW" @click="showPassWord">
                          <span class="material-icons" style="font-size: 20px; color: #777373;">
                            visibility
                          </span>
                        </span>
                      </span>
                    </div>
                  </div>

                  <div style="background: #f9f9f9; width: 300px;">
                    <div class="input-group mt15" ref="recaptchaGroup" style="">

                      <RecaptchaV2 v-if="showRecaptcha" @expired-callback="onExpired" @load-callback="onVerify"
                        style="width: 100%; position: relative; background: #f9f9f9;" />
                    </div>
                  </div>

                  <div class="form-group mt15">
                    <button class="loginbtn" style="width: 70.05px; height: 34px" ref="loginButton">
                      <span v-if="!sending">Login</span>
                      <span v-else>
                        <looping-rhombuses-spinner :animation-duration="1000" :rhombus-size="6" :color="'#fff'" />
                      </span>
                    </button>
                  </div>

                  <p style="text-align: left;">
                    <router-link to="/forgot" class="login-link"><small>Forgot Password?</small></router-link>
                  </p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <privacy-banner />



  </section>
</template>
<script>
import axios from "axios";
import { LoopingRhombusesSpinner } from "epic-spinners";
import { RecaptchaV2 } from "vue3-recaptcha-v2";
import { nextTick } from 'vue';
import { onMounted, ref } from 'vue';
import { jwtDecode } from "jwt-decode";
import { gsap } from 'gsap';
import PrivacyBanner from '../components/General/privacyBanner.vue'



export default {
  name: "Login",
  components: {
    LoopingRhombusesSpinner,
    RecaptchaV2,
    PrivacyBanner
  },
  data() {
    return {
      csrfToken: '',
      username: "",
      password: "",
      error: null,
      failure: false,
      feedback: "",
      errors: [],
      sending: false,
      maintenanceMode: false,
      locked: false,
      unsupported: false,
      userIP: "",
      robot: false,
      usedEmail: false,
      showPW: false,
      showRecaptcha: true,
      isMounted: false,
      needsReset: false,
      newsPosts: null,
    };
  },

  methods: {
    generateCSRFToken() {
      return Math.random().toString(36).substring(2) + Date.now().toString(36);
    },
    animateLoginCard() {
      const tl = gsap.timeline();

      tl.from(this.$refs.loginCard, {
        duration: 1,
        y: 50,
        opacity: 0,
        ease: 'power2.out',
      })
        .from(
          this.$refs.cardHeader,
          {
            duration: 1,
            opacity: 0,
            x: -20,
            ease: 'power1.out',
          },
          '-=0.3' // Overlap with card animation
        )

    },
    animateRecaptcha() {
      gsap.from(this.$refs.recaptchaGroup, {
        duration: 0.8, // Smooth fade duration
        opacity: 0,
        ease: 'power1.out',
      }, '-=1.4');
    },

    animateFailure() {
      gsap.to(this.$refs.loginCard, {
        duration: 0.2,
        x: -10,
        repeat: 3,
        yoyo: true, // Back and forth
        ease: 'power1.inOut',
        onComplete: () => gsap.set(this.$refs.loginCard, { x: 0 }), // Reset position
      });
    },


    refreshPage: function () {
      window.location.reload();
      console.log("refreshed")
    },
    checkUserLock: function () {
      //console.log("Check to see of the user is locked");
    },
    showPassWord: function () {
      this.showPW = true;
    },
    hidePassWord: function () {
      this.showPW = false;
    },

    displayRecaptcha() {
      nextTick(() => {
        this.showRecaptcha = true;
      });
    },
    hideRecaptcha() {
      this.showRecaptcha = false;
    },
    
    loginNEW() {
      localStorage.removeItem("SSCUSER");
      const check = this.checkEmail(this.username);

      if (check === true) {
        this.usedEmail = true;
      } else {
        if (this.robot) {
          this.usedEmail = false;
          this.sending = true;


          let axiosConfig = {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
            },
          };

          const postData = {
            username: this.username,
            password: this.password,
            ip: this.userIP,
            _token: this.csrfToken
          };

          return axios
            .post(`https://spacenet3api.spacesaver.com/api/v1/loginspacenet`, postData, axiosConfig)
            .then((response) => {
              if (response.data.success) {
                this.showRecaptcha = false;
                localStorage.setItem("SSCUSER", response.data.token);

                // Set the necessary state for logged-in user
                this.$store.commit("SET_TOKEN", response.data.token);
                this.$store.commit("SET_USER", response.data.token);
                this.$store.commit("SET_LOGIN", true);

                /*
                if (this.$store.state.user.Roles.includes("ManageExpeditedOrders") || this.$store.state.user.ACId.includes(0)) {
                  this.$store.commit("SET_EO_COUNT");
                }
                */ 
                this.$store.commit("SET_NEW_POST_COUNT");
                this.$store.commit("showNavigation");


                // check for needed reset
                const token = localStorage.getItem("SSCUSER");
                const decoded = jwtDecode(token);
                // console.log(decoded.LastReset);
                const lastResetDate = new Date(decoded.LastReset);
                const currentDate = new Date(); // Get current date
                // Calculate the difference in years
                const oneYearInMilliseconds = 365 * 24 * 60 * 60 * 1000; // 1 year in milliseconds
                const isOlderThanOneYear = currentDate - lastResetDate > oneYearInMilliseconds;


                if (isOlderThanOneYear) {

                  console.log("The date is older than a year.");
                  this.failure = true;
                  setTimeout(() => this.failure = false, 2000);
                  this.handleError("Please update your password to maintain account security.")
                  this.$router.push({ path: "/forgot" });



                } else {
                  console.log("The date is within the last year.");
                  console.log("current date " + currentDate)
                  console.log("reset date " + lastResetDate)

                  /// Get the redirect path, defaulting to '/home' if 'from' is not provided
                  let redirectPath = this.$route.query.from || '/home';
                  let query = { ...this.$route.query };

                  // Remove 'from' from query to avoid carrying it
                  delete query.from;

                  // If 'from' contains a query string (e.g., '/from-the-fort/october-2025?preview=true'),
                  // extract the path and merge its query parameters
                  if (redirectPath.includes('?')) {
                    const [path, queryString] = redirectPath.split('?');
                    redirectPath = path; // Update redirectPath to just the path part
                    // Parse query string into an object
                    const parsedQuery = queryString.split('&').reduce((acc, param) => {
                      const [key, value] = param.split('=');
                      acc[key] = value;
                      return acc;
                    }, {});
                    // Merge parsed query parameters with existing query
                    query = { ...query, ...parsedQuery };
                  }

                  // Redirect with the path and all query parameters
                  this.$router.push({ path: redirectPath, query }).then(() => {
                    this.sending = false;
                    window.location.reload();
                  });



                  /*
                  const redirectPath = this.$route.query.from || "/home";
                  this.$router.push({ path: redirectPath }).then(() => {
                    this.sending = false;
                    window.location.reload();
                  });
                  */


                }


              } else {
                this.failure = true;
                setTimeout(() => this.failure = false, 2000);
                this.handleError("There seems to be an issue with your credentials.");
              }
            })
            .catch(() => {
              this.failure = true;
              setTimeout(() => this.failure = false, 2000);
              this.handleError("There seems to be an issue with your credentials");
            });
        } else {
          this.failure = true;
          setTimeout(() => this.failure = false, 2000);
          this.handleError("reCAPTCHA verification is needed to log in");
        }
      }
    },

    handleError(message) {
      this.sending = false;
      this.$toast.error(message, { hideProgressBar: false, icon: false, timeout: 8000 });
    },

    login() {


      console.log('logging in')
      localStorage.removeItem("SSCUSER");
      const check = this.checkEmail(this.username);

      if (check == true) {
        this.usedEmail = true;
        console.log("is an email");
      } else {
        this.usedEmail = false;
        console.log("not an email");
      }

      // if (this.robot && check == false) {
      if (check == false) {
        //console.log("in here");
        this.sending = true;
        var postData = {
          username: this.username,
          password: this.password,
          ip: this.userIP,
        };

        this.$store
          .dispatch("login", postData)
          .then((response) => {
            //console.log("Response " + response);
            //this.$router.push("/home");
            //next({ name: "Login", query: { from: loginpath } });


            if (response) {

              setTimeout(() => {
                if (this.$route.query.from) {
                  this.$router.push({ path: this.$route.query.from });
                  this.sending = false;
                } else {
                  this.$router.push({ path: "/home" });
                  this.sending = false;
                }
              }, 5000);


              /*

              if (this.$route.query.from) {

                //console.log("has query");
                this.$router.push({ path: this.$route.query.from });

              } else {

                //console.log("has no query");
                this.$router.push({ path: "/home" });

              }
              */

              // this.$store.commit("SET_TOKEN", localStorage.getItem("SSCUSER"));
              // this.$router.push("/home");


            } else {

              this.sending = false;
              this.failure = true;
              setTimeout(() => this.failure = false, 2000);

            }
          })
          .catch((err) => {
            console.log("error " + err);
            this.sending = false;
            this.$toast.error("There seems to be an issue with your credentials.", {
              hideProgressBar: false,
              icon: false,
            });

            // this.failure = true;
            // setTimeout(() => this.failure = false, 2000);
            //setTimeout(function() { this.failure = false; }, 2000);
            /*
            this.$noty.error(
              "There seems to be an issue with your credentials."
            );
            */
            //this.feedback = "There seems to be an issue with your credentials.";

          });


        this.$store.commit('showNavigation');
        // localStorage.setItem('isLoggedIn', '1');
        localStorage.setItem('SSCUSER', user);


      }
    },

    clearShake: function () {
      this.failure = false;
    },

    onVerify: function (response) {
      if (response) this.robot = true;
    },

    onError: function () {
      // if (response) this.robot = true;
      this.$toast.error("There seems to be an error with reCAPTCHA verification.", {
        hideProgressBar: false,
        icon: false,
      });
    },


    onExpired: function () {
      // if (response) this.robot = true;
      this.$toast.error("reCAPTCHA verification has expired.", {
        hideProgressBar: false,
        icon: false,
      });
    },

    /*
    showNavigation() {
      this.$store.commit("showNavigation");
    },

    hideNavigation() {
      this.$store.commit("hideNavigation");
    },
    */

    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },


    checkEmail(emailAddress) {
      var sQtext = "[^\\x0d\\x22\\x5c\\x80-\\xff]";
      var sDtext = "[^\\x0d\\x5b-\\x5d\\x80-\\xff]";
      var sAtom =
        "[^\\x00-\\x20\\x22\\x28\\x29\\x2c\\x2e\\x3a-\\x3c\\x3e\\x40\\x5b-\\x5d\\x7f-\\xff]+";
      var sQuotedPair = "\\x5c[\\x00-\\x7f]";
      var sDomainLiteral = "\\x5b(" + sDtext + "|" + sQuotedPair + ")*\\x5d";
      var sQuotedString = "\\x22(" + sQtext + "|" + sQuotedPair + ")*\\x22";
      var sDomain_ref = sAtom;
      var sSubDomain = "(" + sDomain_ref + "|" + sDomainLiteral + ")";
      var sWord = "(" + sAtom + "|" + sQuotedString + ")";
      var sDomain = sSubDomain + "(\\x2e" + sSubDomain + ")*";
      var sLocalPart = sWord + "(\\x2e" + sWord + ")*";
      var sAddrSpec = sLocalPart + "\\x40" + sDomain; // complete RFC822 email address spec
      var sValidEmail = "^" + sAddrSpec + "$"; // as whole string

      var reValidEmail = new RegExp(sValidEmail);

      return reValidEmail.test(emailAddress);
    },
    detectIE() {
      var ua = window.navigator.userAgent;
      var msie = ua.indexOf("MSIE ");

      //if (msie > 0 || navigator.userAgent.match(/Trident.*rv\:11\./)) {
      if (msie > 0 || msie == 11) {
        // If Internet Explorer, return version number
        //alert(parseInt(ua.substring(msie + 5, ua.indexOf(".", msie))));
        this.unsupported = true;
      } // If another browser, return 0
      else {
        // alert("otherbrowser");
        return;
      }

      return false;
    },

    faqSync: function () {
      console.log("ran")
      return axios
        .get(
          `https://news.spacesaver.com/api/faqs?sort[0]=publishedAt:desc`
        )
        .then((response) => {
          this.$store.commit("UPDATE_FAQS_HOME", this.faqPosts);
        });
    },

    async newsSync() {

      try {
        const response = await fetch(
          `https://news.spacesaver.com/api/news-feeds?sort[0]=publishedAt:desc&pagination[limit]=20&populate=*`
        );
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        this.newsPosts = data.data;
        // Save to localStorage
        localStorage.setItem('announcementHomePosts', JSON.stringify(this.newsPosts));
        this.$store.commit("UPDATE_ANNOUNCEMENTS_HOME", this.newsPosts);
      } catch (error) {
        console.error('Error fetching news:', error.message);
      }

    }



  },

  computed: {
  },

  beforeMount() {
    this.hideRecaptcha(); // Hide reCAPTCHA when leaving the component
  },
  mounted() {
    this.displayRecaptcha();
    this.$nextTick(() => {
      this.animateLoginCard();
    });
  },
  onMounted() {
    this.isMounted = true;
  },
  beforeDestroy() {
    // console.log('Component beforeDestroy');
  },
  destroyed() {
    // console.log('Component destroyed');
  },

  created() {  
    this.csrfToken = this.generateCSRFToken();
    this.toggleBodyClass("removeClass", "wsactive");
    localStorage.removeItem('announcementHomePosts');
    this.newsSync();
    this.$store.commit("SET_FAQS_HOME");



    fetch("https://api.ipify.org?format=json")
      .then((x) => x.json())
      .then(({ ip }) => {
        this.userIP = ip;
      });
  },

  watch: {
    failure(newVal) {
      if (newVal) this.animateFailure();
    },
  },
};
</script>

<style>
/* Container styling */
#rc-anchor-container {
  width: 100%;
  /* Match your form’s input width */
  max-width: 300px;
  /* reCAPTCHA’s default width */
  margin: 15px auto;
  /* Center it like your form groups */
  border-radius: 4px;
  /* Soften edges */
  background-color: #f9f9f9;
  /* Light gray to blend with card */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  /* Subtle shadow */
  overflow: hidden;
  /* Contain child elements */
}

/* Checkbox area */
.rc-anchor-content {
  padding: 10px;
  /* Add breathing room */
}

/* "I'm not a robot" text */
.rc-anchor-checkbox-label {
  font-family: Arial, sans-serif;
  /* Match your app’s font */
  font-size: 14px;
  /* Slightly smaller */
  color: #333;
  /* Darker for readability */
}

/* Checkbox itself */
.recaptcha-checkbox {
  border: 2px solid #28a745;
  /* Green to match your .bggreen */
  border-radius: 3px;
}

/* Checked state (if visible) */
.recaptcha-checkbox-checked {
  background-color: #28a745;
  /* Green fill */
}

/* Footer (Privacy/Terms) */
.rc-anchor-normal-footer {
  padding: 5px 10px;
}

.rc-anchor-logo-text {
  font-size: 10px;
  color: #666;
  /* Softer gray */
}

.rc-anchor-pt a {
  color: #007bff;
  /* Blue links to match typical UI */
  text-decoration: none;
}

.rc-anchor-pt a:hover {
  text-decoration: underline;
}

.rc-anchor-light.rc-anchor-normal,
.rc-anchor-light.rc-anchor-compact {
  border: none !important;
}
</style>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}

.card-header {
  display: flex;
  display: flex;
  align-items: center;
}

.login {
  display: none;
}

.mt200 {
  margin-top: 200px;
}

.bggreen {
  background: #00b4b4;
}

.green {
  color: #00b4b4;
}

.bordernone {
  border: none;
}

.mt15 {
  margin-top: 15px;
}

.bs {
  -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 3px 1px -2px rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2);
}

.card-header {
  border-bottom: none;
}

.loginbtn {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border: none;
  background: #00b4b4;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
  padding: 5px 15px;
}

.mb0 {
  margin-bottom: 0 !important;
}

.ml10 {
  margin-left: 10px;
}

.login-link {
  cursor: pointer;
  color: #00b4b4;
  line-height: 1;
}

#loginPage {
  height: 100vh !important;
  width: 100vw !important;
  /*background-image: linear-gradient(45deg, rgba(66,66,66, 0.96), rgba(8,83,156, 0.45)), url('SpaceSaver-0041.jpeg');*/

  width: 100%;
  background-size: cover;
  text-align: center;
  background-position: center;
  color: #fff;
  background-color: #DDE3EA;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000'%3E%3Cg stroke='%23D8DEE5' stroke-width='0' stroke-miterlimit='99' %3E%3Cpolygon fill='%23E2E8F0' points='-70 85 100 0 0 150 200 0 0 300 350 0 0 500 550 0 0 750 800 0 0 1050 1100 0 0 1400 1450 0 0 1850 1950 0 1000 3000 -99 3000'/%3E%3C/g%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
}

/*
#loginPage::before {
  content: "";
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='414.5' height='715' viewBox='0 0 200 345'%3E%3Cdefs%3E%3Cfilter id='d' width='200%25' height='200%25'%3E%3CfeGaussianBlur in='SourceGraphic' stdDeviation='12'%3E%3C/feGaussianBlur%3E%3C/filter%3E%3ClinearGradient id='a' gradientUnits='objectBoundingBox' x1='0' y1='1' x2='0' y2='0'%3E%3Cstop offset='0' stop-color='%23e1e3e4'/%3E%3Cstop offset='1' stop-color='%23dbdddf'/%3E%3C/linearGradient%3E %3CradialGradient id='b' gradientUnits='objectBoundingBox' cx='.5' cy='.5' r='1'%3E%3Cstop offset='0' stop-color='%23c2c3c5'/%3E%3Cstop offset='1' stop-color='%23a1a3a4'/%3E%3C/radialGradient%3E%3CradialGradient id='c' gradientUnits='objectBoundingBox' cx='.5%25' cy='.5%25' r='4'%3E%3Cstop offset='0' stop-color='%23dbdddf'/%3E%3Cstop offset='1' stop-color='%23c2c3c5'/%3E%3C/radialGradient%3E%3Csymbol id='e'%3E%3Cpolygon fill='url(%23a)' points='200 57.5 100 0 0 57.5 100 115'/%3E%3Cpolygon fill='url(%23b)' points='100 115 0 57.5 0 172.5 100 230'/%3E%3Cpolygon fill='url(%23c)' points='100 115 100 230 200 172.5 200 57.5'/%3E%3C/symbol%3E%3Csymbol id='f'%3E%3Cpolygon filter='url(%23d)' fill-opacity='0' points='200 172.5 113.5 107.5 100 0 87.5 107.5 0 172.5 100.5 129.5'/%3E%3C/symbol%3E%3C/defs%3E%3Cuse xlink:href='%23e' y='-57.5'/%3E%3Cuse xlink:href='%23e' x='100' y='115'/%3E%3Cuse xlink:href='%23e' x='-100' y='115'/%3E%3Cuse xlink:href='%23e' y='287.5'/%3E%3Cuse xlink:href='%23f' x='-100'/%3E%3Cuse xlink:href='%23f' x='100'/%3E%3Cuse xlink:href='%23f' y='172.5'/%3E%3Cuse xlink:href='%23f' y='-172.5'/%3E%3Cuse xlink:href='%23f' x='-100' y='345'/%3E%3Cuse xlink:href='%23f' x='100' y='345'/%3E%3Cuse xlink:href='%23f' x='200' y='172.5'/%3E%3Cuse xlink:href='%23f' x='200' y='172.5'/%3E%3C/svg%3E");
  background-size: cover;
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  opacity: 0.5;
}
  */

.browser-list {
  list-style-type: none;
  padding-left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  transition: scale;
}

.browser-list li {
  padding: 5px;
  transition: all 0.2s ease-in-out;
}

.browser-list li:hover {
  transform: scale(1.1);
}

.browser-list li:active {
  transform: scale(1.1);
}

.password-icon {
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.password-icon:hover {
  color: #00b4b4;
}

.password-icon:active {
  color: #00b4b4;
}

.failure {
  animation: shake 0.82s cubic-bezier(.36, .07, .19, .97) both;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
}

@keyframes shake {

  10%,
  90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(2px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(4px, 0, 0);
  }
}

.recaptcha-container {
  display: inline-block;
  transform: scale(0.77);
  transform-origin: 0 0;
}

@media (max-width: 400px) {
  .recaptcha-container {
    transform: scale(0.55);
    transform-origin: 0 0;
  }
}

@media (max-width: 300px) {
  .recaptcha-container {
    transform: scale(0.45);
    transform-origin: 0 0;
  }
}

@media (max-width: 399px) {
  #loginContainer {
    width: 90%;
  }
}

@media (min-width: 400px) {
  #loginContainer {
    width: 400px;
  }
}

/* Default Bootstrap input styling (optional, for reference) */
.form-control {
  border: 1px solid #ced4da;
  /* Bootstrap’s default border */
}

/* Remove focus outline and prevent border darkening */
.form-control:focus {
  outline: none !important;
  /* No outline */
  box-shadow: none !important;
  /* No Bootstrap glow */
  -webkit-box-shadow: none !important;
  /* No Chrome glow */
  border-color: #ced4da !important;
  /* Lock to Bootstrap’s default border color */
}

/* Handle autofill: no outline, no glow, no blue background */
.form-control:-webkit-autofill,
.form-control:-webkit-autofill:hover,
.form-control:-webkit-autofill:focus,
.form-control:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px #fff inset !important;
  /* Force white background */
  box-shadow: none !important;
  /* No glow */
  outline: none !important;
  /* No outline */
  border-color: #ced4da !important;
  /* Match Bootstrap’s default border */
  -webkit-text-fill-color: #495057 !important;
  /* Match Bootstrap’s text color */
}

/* Disabled inputs */
.form-control:disabled,
.form-control:disabled:focus {
  outline: none !important;
  box-shadow: none !important;
  border-color: #ced4da !important;
  /* Keep default border */
  background-color: #e9ecef !important;
  /* Bootstrap’s disabled bg */
}
</style>
